import { Component, Input, forwardRef, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { InputBase } from './input-base';
import { OptionItem } from '../../data/option-item';

@Component({
  selector: 'app-phone-input',
  templateUrl: './phone-input.component.html',
  styleUrls: ['./phone-input.component.scss']
})
export class PhoneInputComponent extends InputBase {
  
  @Input() phoneTypes: OptionItem[] = [
    { value: 'Mobile', label: 'Mobile' },
    { value: 'Home', label: 'Home' },
    { value: 'Work', label: 'Work' }
  ];
  
  // Individual FormControls for each phone field
  @Input() phoneTypeControl!: FormControl;
  @Input() phoneCountryCodeControl!: FormControl;
  @Input() phoneAreaCodeControl!: FormControl;
  @Input() phoneNumberControl!: FormControl;

}

